import type { DehydratedState } from "@tanstack/vue-query";
import {
  QueryClient,
  VueQueryPlugin,
  dehydrate,
  hydrate,
} from "@tanstack/vue-query";

export default defineNuxtPlugin((nuxt) => {
  const vueQueryState = useState<DehydratedState | null>("vue-query");

  const client = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 3600,
        refetchOnMount: false,
      },
    },
  });

  nuxt.vueApp.use(VueQueryPlugin);

  if (import.meta.server) {
    nuxt.hooks.hook("app:rendered", () => {
      vueQueryState.value = dehydrate(client);
    });
  }

  if (import.meta.client) hydrate(client, vueQueryState.value);
});
